module.exports = __webpack_public_path__ + "static/img/statusCorrectChester.7659d7dc.gif";